import { InputControl, MenuSelect, TextArea } from "src/common/formConstants";
import { SimpleGrid, VStack } from "@chakra-ui/react";

import { CommunicationDetailsForm } from "src/types/FormTypes";
import { IndianStates } from "src/utils/registrationFormUtils";
import { Regisration_Form_Labels_English } from "src/common/constants/englishLabels";
import { Regisration_Form_Labels_Hindi } from "src/common/constants/hindiLabels";

type AddressDetailsProps = {
    isPermanentAddressEnabled: boolean;
    communicationDetailsValues: CommunicationDetailsForm;
    handleCommunicationDetailsChanged: (fieldName: string, value: string) => void;
    isCurrentFormValid: boolean;
}

const AddressDetails: React.FC<AddressDetailsProps> = (props: AddressDetailsProps) => {
    const { isPermanentAddressEnabled, communicationDetailsValues, isCurrentFormValid, handleCommunicationDetailsChanged } = props
    const { streetAddress, permanentStreetAddress, city, permanentCity, state, permanentstate, postOffice, permanentpostOffice,
        district, permanentdistrict, permanentPinCode, pinCode } = communicationDetailsValues
    const isDisabled = isPermanentAddressEnabled && communicationDetailsValues.isPermanentAddressEnabled;

    const streetAddressData = {
        name: isPermanentAddressEnabled ? "permanentStreetAddress" : "streetAddress",
        value: (isPermanentAddressEnabled ? permanentStreetAddress : streetAddress) || ""
    }

    const districtData = {
        name: isPermanentAddressEnabled ? "permanentdistrict" : "district",
        value: (isPermanentAddressEnabled ? permanentdistrict : district) || ""
    }

    const pinCodeData = {
        name: isPermanentAddressEnabled ? "permanentPinCode" : "pinCode",
        value: (isPermanentAddressEnabled ? permanentPinCode : pinCode) || ""
    }

    const cityData = {
        name: isPermanentAddressEnabled ? "permanentCity" : "city",
        value: (isPermanentAddressEnabled ? permanentCity : city) || ""
    }

    const stateData = {
        name: isPermanentAddressEnabled ? "permanentstate" : "state",
        value: (isPermanentAddressEnabled ? permanentstate : state) || ""
    }

    const postOfficeData = {
        name: isPermanentAddressEnabled ? "permanentpostOffice" : "postOffice",
        value: (isPermanentAddressEnabled ? permanentpostOffice : postOffice) || ""
    }

    return (
        <VStack my={4} py={4} borderTop="1px solid #D5DBE3" w="100%">
            <SimpleGrid width="100%" columns={[1, 1, 1, 2]} gap={[4, 4, 4, 10]}>
                <TextArea isDisabled={isDisabled} isValidate={isCurrentFormValid} isMandatory={!isDisabled} placeholder="Enter street address" name={streetAddressData.name} onChange={handleCommunicationDetailsChanged} value={streetAddressData.value} hindiLabel={Regisration_Form_Labels_Hindi.BUSINESS_DETAILS} englishLabel={"STREET ADDRESS"} />
                <VStack>
                    <InputControl isDisabled={isDisabled} isValidate={isCurrentFormValid} isMandatory={!isDisabled} onChange={handleCommunicationDetailsChanged} name={cityData.name} value={cityData.value} placeholder="Enter your village/city" hindiLabel={Regisration_Form_Labels_Hindi.ADDRESS_LINE2} englishLabel={"VILLAGE/CITY"} />
                    <SimpleGrid width="100%" columns={[1, 1, 1, 2]} gap={4}>
                        <VStack>
                            <MenuSelect isDisabled={isDisabled} isValidate={isCurrentFormValid} isMandatory={!isDisabled} onSelect={handleCommunicationDetailsChanged} name={stateData.name} value={stateData.value} placeholder="Select your state" hindiLabel={Regisration_Form_Labels_Hindi.STATE} englishLabel={Regisration_Form_Labels_English.STATE} values={IndianStates} />
                            <InputControl isDisabled={isDisabled} isValidate={isCurrentFormValid} onChange={handleCommunicationDetailsChanged} name={postOfficeData.name} value={postOfficeData.value} placeholder="Enter your post office" hindiLabel={Regisration_Form_Labels_Hindi.ALTERNATE_EMAIL_ID} englishLabel={"POST OFFICE"} />
                        </VStack>
                        <VStack>
                            <InputControl isDisabled={isDisabled} isMandatory={!isDisabled} isValidate={isCurrentFormValid} onChange={handleCommunicationDetailsChanged} name={districtData.name} value={districtData.value} placeholder="Enter your district" hindiLabel={Regisration_Form_Labels_Hindi.ALTERNATE_EMAIL_ID} englishLabel={"DISTRICT"} />
                            <InputControl isDisabled={isDisabled} isNumber={true} length={6} isValidate={isCurrentFormValid} isMandatory={!isDisabled} onChange={handleCommunicationDetailsChanged} name={pinCodeData.name} value={pinCodeData.value} placeholder="Enter your 6 digit pin code" hindiLabel={Regisration_Form_Labels_Hindi.PIN_CODE} englishLabel={Regisration_Form_Labels_English.PIN_CODE} />
                        </VStack>
                    </SimpleGrid>
                </VStack>
            </SimpleGrid>
        </VStack>
    )
}

export default AddressDetails;